<template lang="pug">
.media-gallery
  .gallery-grid(:class="{ 'admin-grid': adminMode }")
    template(v-for="(m, ix) in items")
      div(style="position: relative")
        MediaThumbnail(
          :key="m.id",
          :media="m",
          :index="ix",
          :admin-mode="adminMode",
          @click="showDetail(m)",
          :selected="selectedIds?.has(m.id)",
          @toggle="toggleSelection"
        )

        icon.small(
          name="gps",
          @click="editGps(m)",
          style="position: absolute; right: 1vw; top: 1vw",
          :class="gpsMode(m)"
        ) 

    modal(:visible="gpsModalOpen")
      template(v-slot:header) Position bestimmen
      template(v-slot:body)
        gps-editor(
          ref="gpsEditor",
          :media="editingGpsFor",
          :initialCoords="gpsEditorCenter",
          :initialZoom="gpsEditorZoom"
          :hasOwnCoords="!!editingGpsFor?.gps_latitude"
        )
      template(v-slot:footer)
        button3d.cancel(@click="closeGpsModal")
          icon.small(name="close")
        button3d.save(@click="confirmGpsSelection")
          icon.small(name="ok")
    //- .scroll-sentinel(ref="sentinel")
    div(ref="sentinel")
      span(v-if="!endOfList") Lade mehr...
      span(v-else) Keine weiteren Einträge.

  media-item-detail(
    v-if="selectedItem",
    :media="selectedItem"
    :itemId="selectedItem.id",
    @close="selectedItem = null"
    :adminMode="adminMode"
  )
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MediaItemDetail from "./MediaItemDetail.vue";
import MediaDetail from "./MediaDetail.vue";
import MediaThumbnail from "./MediaThumbnail.vue";
import Icon from "@/components/Icon.vue";
import GpsEditor from "./GpsEditor.vue";
import Modal from "@/components/Modal.vue";
import Button3d from "./Button3d.vue";
import api from "@/api";

export default {
  name: "MediaGallery",
  props: ["adminMode", "selectedIds"],
  components: {
    MediaDetail,
    MediaItemDetail,
    MediaThumbnail,
    Icon,
    GpsEditor,
    Modal,
    Button3d,
  },
  data() {
    return {
    //   selectedItems: new Set(), // nur im Admin-Modus relevant
      loadPage: 1,
      appendPage: 1,
      perPage: 40,
      selectedItem: null,
      loading: false,
      editingGpsFor: null,
      mapCenter: this.initialCenter,
      zoomLevel: this.initialZoom,
      lastGpsCenter: null,
      lastGpsZoom: null,
    };
  },
  computed: {
    ...mapGetters({
      total: "media/total",
      items: "media/items",
      item: "media/item",
      filter: "media/filter",
      groups: "faces/groups",
    }),
    endOfList() {
      console.log("end of page", this.appendPage * this.perPage, this.total);
      return this.appendPage * this.perPage >= this.total;
    },
    gpsModalOpen() {
      return this.editingGpsFor != null;
    },
  },
  async mounted() {
    await this.load();
    // this.setupObserver();
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    ...mapActions({
      list: "media/list",
      append: "media/append",
      count: "media/count",
      loadGroups: "faces/loadGroups",
      getItem: "media/item",
    }),
    gpsMode(media) {
      if (media.gps_latitude && media.gps_longitude) return "present";
      return "absent";
    },
    editGps(media) {

      this.gpsEditorCenter =
        media.gps_latitude && media.gps_longitude
          ? { lat: media.gps_latitude, lng: media.gps_longitude }
          : this.lastGpsCenter || { lat: 51.82949, lng: 6.244759 };

      this.gpsEditorZoom = media.gps_latitude ? 18 : this.lastGpsZoom || 14;
      
      console.log('edit gps:', this.gpsEditorCenter, this.gpsEditorZoom);

      this.lastGpsCenter = this.gpsEditorCenter;
      this.lastGpsZoom = this.gpsEditorZoom;

      this.editingGpsFor = media;
    },
    closeGpsModal() {
      this.editingGpsFor = null;
    },
    confirmGpsSelection() {
      const coords = this.$refs.gpsEditor.getCurrentCoordinates();
      const center = this.$refs.gpsEditor.getCurrentCenter();
      const zoom = this.$refs.gpsEditor.getCurrentZoom();

      if (coords && this.editingGpsFor) {
        this.editingGpsFor.gps_latitude = coords.latitude;
        this.editingGpsFor.gps_longitude = coords.longitude;

        this.updateMediaGps(this.editingGpsFor.id, coords);
      }

      this.lastGpsCenter = center;
      this.lastGpsZoom = zoom;
      this.closeGpsModal();
    },
    updateMediaGps(id, coords) {
      // Beispielhafte API Anfrage
      api.media.setGps(id, coords.latitude, coords.longitude);
    },
    toggleSelection(id) {
      const newSet = new Set(this.selectedIds);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
    //   this.selectedItems = newSet; // ⚠️ Dies triggert Reaktivität
      this.$emit("update:selectedIds", newSet);
    },
    async showDetail(item) {
      await this.getItem(item.id);
      this.selectedItem = this.item;
      console.log("show detail", this.item);
    },
    closeDetail() {
      this.selectedItem = null;
    },
    async load() {
      if (this.loading) return;
      this.loading = true;

      const offset = (this.loadPage - 1) * this.perPage;
      await this.count(this.filter);
      console.log("loaded count", this.loadPage, this.total);
      await this.list({
        ...this.filter,
        page: this.loadPage,
        offset,
        limit: this.perPage,
      });
      console.log("loaded filter", this.filter, this.loadPage);
      this.appendPage = this.loadPage; // initialisierung
      this.loading = false;

      // Wichtig: Leichte Verzögerung, damit DOM sicher steht
      setTimeout(() => {
        this.setupObserver();
      }, 200); // 200–300ms sind oft ausreichend
    },
    openItem(media) {
      this.selectedItem = media;
    },
    formatDate(date) {
      return date ? new Date(date).toLocaleDateString() : "";
    },
    setupObserver() {
      this.observer = new IntersectionObserver(
        async (entries) => {
          const entry = entries[0];
          if (entry.isIntersecting && !this.endOfList && !this.loading) {
            this.loading = true;
            this.appendPage++;
            console.log("▶ Sentinel sichtbar – lade Seite", this.appendPage);
            await this.append({
              ...this.filter,
              page: this.appendPage,
              offset: (this.appendPage - 1) * this.perPage,
              limit: this.perPage,
            });
            console.log("appended filter", this.filter, this.appendPage);
            this.loading = false;
          }
        },
        {
          root: null, // viewport
          threshold: 0.1, // 10% sichtbar reicht
        }
      );

      this.$nextTick(() => {
        const sentinel = this.$refs.sentinel;
        if (sentinel) {
          this.observer.observe(sentinel);
        }
      });
    },
  },
  watch: {
    filter: {
      async handler() {
        console.log("init load");
        this.loadPage = 1;
        this.appendPage = 1;
        if (this.observer) {
          this.observer.disconnect();
        }
        await this.load();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.media-gallery {
  flex: 1 0;
  font-size: 3vw;
  color: black;
  display: flex;
  flex-direction: column;
  overflow: auto;
  .gallery-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    span,
    button {
      margin: 0 0.5rem;
    }
  }
  .gallery-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1vw;
    .media-item {
      cursor: pointer;
      border: 1px solid #ccc;
      padding: 0.25rem;
      background: #f8f8f8;
      img {
        max-width: 100%;
        height: auto;
        display: block;
      }
      .meta {
        font-size: 0.8rem;
        margin-top: 0.25rem;
        display: flex;
        flex-direction: column;
      }
    }
  }
  .admin-grid {
    grid-template-columns: 1fr;
  }
}
.present {
  color: green;
}
.absent {
  color: red;
}
</style>
